import { backButton } from '@tma.js/sdk-react';
import { useEffect } from 'react';

/** Системная кнопка «Назад» Telegram, пока экран открыт (вне Telegram — ничего не делает). */
export function useBackButton(onBack: () => void): void {
  useEffect(() => {
    try {
      if (!backButton.mount.isAvailable()) return;
      backButton.mount();
      backButton.show();
      const off = backButton.onClick(onBack);
      return () => {
        off();
        if (backButton.hide.isAvailable()) backButton.hide();
      };
    } catch {
      return undefined;
    }
  }, [onBack]);
}
